import { render, staticRenderFns } from "./Shades.vue?vue&type=template&id=c3d68156&scoped=true&"
import script from "./Shades.vue?vue&type=script&lang=js&"
export * from "./Shades.vue?vue&type=script&lang=js&"
import style0 from "./Shades.vue?vue&type=style&index=0&id=c3d68156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d68156",
  null
  
)

component.options.__file = "Shades.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VContainer,
  VFlex,
  VIcon,
  VLayout,
})
